import styled from "styled-components";
import { MapViewToggle } from "../App/styled.js";

export {
  FiltersPanel as AppFilters,
  MapFiltersButton,
  MapLegend as Legend,
  MapButtonsPanel as StateMapButtons,
} from "../MapChrome/styled.js";

export const StateMapViewToggle = styled(MapViewToggle)`
  @media (min-width: 640px) {
    display: flex;
    justify-content: flex-start;
    padding-left: 20px;
    /* Reserve room on the right for MapFiltersButton, a separate
       absolutely-positioned element sharing this row: flex-wrap only
       wraps once items exceed *this* container's own box, so without this
       the toggle happily grows underneath the filter button before
       reaching its own right edge. */
    padding-right: 200px;
    /* Keep the full-width, wrapping layout from the base MapViewToggle (so
       buttons drop to a second row instead of overflowing past the edge on
       narrower desktop widths), but don't let the container's own hit-box
       swallow clicks over its empty space, since MapFiltersButton is
       absolutely positioned in that same area. */
    pointer-events: none;

    > * {
      pointer-events: auto;
    }
  }
`;
